import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/email', [
    {
      path: '',
      name: 'email',
      redirect: { name: 'email-list' },
    },
    {
      path: '/list',
      name: 'email-list',
      component: () => import('@/views/email/EmailList.vue'),
    },
    {
      path: '/create',
      name: 'email-create',
      component: () => import('@/views/email/EmailCreate.vue'),
    },
    {
      path: '/:emailId(\\d+)?',
      name: 'email-edit',
      component: () => import('@/views/email/EmailEdit.vue'),
    },
  ]);
};
